import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useLanguage } from '../../../contexts/LanguageContext';
import styles from './Settings.module.css';

const Settings: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useLanguage();

    const handleSettingCardClick = (route: string) => {
        navigate(route);
    };
    return (
        <div className={styles.settingsPage}>
            <h2 className="xH1">{t('settings.title')}</h2>
            <div className={styles.settingSection}>
                <h3>{t('settings.section.account')}</h3>
                <div className={styles.horR}></div>

                <div className={styles.settingCards}>
                    <div onClick={() => handleSettingCardClick('accountsettings')} className={styles.settingCard}>
                        <svg width="47" height="38" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path style={{ stroke: 'var(--primary)' }} fill-rule="evenodd" clip-rule="evenodd" d="M18.2503 18.5C23.0341 18.5 26.9481 14.5625 26.9481 9.75C26.9481 4.9375 23.0341 1 18.2503 1C13.4666 1 9.55262 4.9375 9.55262 9.75C9.69758 14.5625 13.6116 18.5 18.2503 18.5Z" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path style={{ stroke: 'var(--primary)' }} d="M35.6459 36.0006C35.6459 26.3756 27.818 18.6465 18.3954 18.6465C8.97291 18.6465 1 26.3756 1 36.0006" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <div className={styles.cardContent}>
                            <h4>{t('settings.card.accountSettings.title')}</h4>
                            <p>{t('settings.card.accountSettings.desc')}</p>
                        </div>
                    </div>
                    <div onClick={() => handleSettingCardClick('profile')} className={styles.settingCard}>
                        <svg width="47" height="38" viewBox="0 0 47 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path style={{ stroke: 'var(--primary)' }} d="M23.5 19C28.3 19 32.5 14.8 32.5 10C32.5 5.2 28.3 1 23.5 1C18.7 1 14.5 5.2 14.5 10C14.5 14.8 18.7 19 23.5 19Z" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path style={{ stroke: 'var(--primary)' }} d="M1 36C1 25 10 19 23.5 19C37 19 46 25 46 36" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <div className={styles.cardContent}>
                            <h4>{t('settings.card.profile.title')}</h4>
                            <p>{t('settings.card.profile.desc')}</p>
                        </div>
                    </div>
                    <div onClick={() => handleSettingCardClick('paymentsettings')} className={styles.settingCard}>
                        <svg width="42" height="29" viewBox="0 0 42 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path style={{ stroke: 'var(--primary)' }} d="M38.0002 1C39.4868 1 40.643 2.16649 40.643 3.66626V24.6631C40.643 26.1628 39.4868 27.3293 38.0002 27.3293H3.64287C2.15625 27.3293 1 26.1628 1 24.6631V3.66626C1 2.16649 2.15625 1 3.64287 1H38.0002Z" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path style={{ stroke: 'var(--primary)' }} d="M1.33038 9.16504H40.1475" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path style={{ stroke: 'var(--primary)' }} d="M27.7591 17.498H35.6877" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <div className={styles.cardContent}>
                            <h4>{t('settings.card.payment.title')}</h4>
                            <p>{t('settings.card.payment.desc')}</p>
                        </div>
                    </div>
                    <div onClick={() => handleSettingCardClick('branches')} className={styles.settingCard}>
                        <svg width="47" height="38" viewBox="0 0 47 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path style={{ stroke: 'var(--primary)' }} d="M21.7 1.90039H8.73999C8.01999 1.90039 7.29999 2.26039 6.93999 2.80039L2.79999 9.82039C1.71999 11.8004 1.53999 13.9604 2.43999 15.9404C3.33999 18.1004 5.13999 18.6404 5.13999 18.6404C9.27999 20.2604 12.7 14.5004 12.7 14.5004C16.12 19.5404 18.46 18.6404 18.46 18.6404C21.88 18.6404 23.5 14.5004 23.5 14.5004C23.5 14.5004 26.02 18.6404 28.72 18.6404C28.72 18.6404 31.24 19.5404 34.48 14.5004C34.48 14.5004 37.9 20.2604 42.04 18.6404C42.04 18.6404 43.66 18.2804 44.74 15.9404C45.46 13.9604 45.28 11.8004 44.2 9.82039L40.06 2.80039C39.7 2.26039 38.98 1.90039 38.26 1.90039H25.12H21.7Z" stroke-width="2" stroke-miterlimit="10" />
                            <path style={{ stroke: 'var(--primary)' }} d="M40.96 18.6406V34.3006C40.96 35.3806 40.06 36.1006 39.16 36.1006H7.83999C6.75999 36.1006 6.03999 35.2006 6.03999 34.3006V18.6406" stroke-width="2" stroke-miterlimit="10" />
                            <path style={{ stroke: 'var(--primary)' }} d="M6.03999 26.0205H40.96" stroke-width="2" stroke-miterlimit="10" />
                        </svg>

                        <div className={styles.cardContent}>
                            <h4>{t('settings.card.branches.title')}</h4>
                            <p>{t('settings.card.branches.desc')}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.settingSection}>
                <h3>{t('settings.section.notifications')}</h3>
                <div className={styles.horR}></div>
                <div className={styles.settingCards}>
                    <div onClick={() => handleSettingCardClick('notifications')} className={styles.settingCard}>
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path style={{ stroke: 'var(--primary)' }} d="M18 8A6 6 0 1 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path style={{ stroke: 'var(--primary)' }} d="M13.73 21a2 2 0 0 1-3.46 0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <div className={styles.cardContent}>
                            <h4>{t('settings.card.notifications.title')}</h4>
                            <p>{t('settings.card.notifications.desc')}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* GL-10 (Go-Live Wave 0): the Employees > "User roles" card linked
                to a pure mock page (Add = TODO, Edit = alert(), no backend).
                Hidden for the pilot; its /settings/userroles route is also
                neutralized in App.tsx. Restore this section when the roles
                backend ships. */}
        </div>
    );
};

export default Settings;